import { createApi } from '@reduxjs/toolkit/query/react';
import { gql } from 'graphql-request';
import { baseQuery } from '@classity-edtech/ui-base';
import { QUESTIONNAIRE } from '../store/actionTypes';
import { Form, Forms, FetchFormsQuery } from './models/questionnaire';

const questionnaireQuery = `{
  id
  name
  displayName
  category {
    displayName
  }
  controls {
    name
    displayName
    note
    position
    options {
      value
      label
      icon
    }
    input {
      label
      max
      min
      pattern
      placeholder
      readonly
      required
      type
      name
      value
    }
    media {
      order
      description
      url
      type
    }
  }
  meta {
    active
    created
    updated
  }
}`;

export const questionnaire = createApi({
  reducerPath: QUESTIONNAIRE,
  baseQuery,
  tagTypes: ['Questionnaire'],
  endpoints: builder => ({
    getQuestionnaires: builder.query<Forms, FetchFormsQuery>({
      query: variables => ({
        document: gql`query GetAllForms($page: Int, $limit: Int) {
          getAllForms(page: $page, limit: $limit) ${questionnaireQuery}
        }`,
        variables,
      }),
      transformResponse: (response: { getAllForms: Forms }) => response?.getAllForms,
    }),
    getQuestionnaire: builder.query<Form, { name: string }>({
      query: variables => ({
        document: gql`query GetFormByName($name: FreeFormName!) {
          getFormByName(name: $name) ${questionnaireQuery}
        }`,
        variables,
      }),
      transformResponse: (response: { getFormByName: Form }) => response?.getFormByName,
    }),
  }),
});

export const { useGetQuestionnairesQuery, useGetQuestionnaireQuery, useLazyGetQuestionnaireQuery } =
  questionnaire;
